import React from 'react'
import './Error.css'


import { useStateValue } from '../utils/Provider/StateProvider';


function Error() {
    const [{error}, dispatch] = useStateValue();

    // Reset Error:
    const resetError = () => {
        dispatch({
            type: 'NOTIFY_ERROR',
            error: null 
        })
    }
    return (
        (error ? 
        <div className='error_notifyContainer'>
            <div className='error_message'>
                {error}
            </div>

            <div className='close_error' onClick={() => resetError()}>
                <i class='fa fa-times'></i>
            </div>
        </div>
        :
        null
    )
    )
}

export default Error